type ChevronDownIconProps = {
  size?: number
}

export function ChevronDownIcon({ size = 24 }: ChevronDownIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M16.4698 6.47021C16.7627 6.17732 17.2374 6.17732 17.5303 6.47021C17.8232 6.76311 17.8232 7.23789 17.5303 7.53076L10.5303 14.5308C10.2374 14.8236 9.76265 14.8236 9.46975 14.5308L2.46973 7.53076C2.17684 7.23787 2.17684 6.76311 2.46973 6.47021C2.76263 6.17732 3.23739 6.17732 3.53028 6.47021L10 12.9399L16.4698 6.47021Z" fill="currentColor" />
    </svg>
  )
}
